export const facultyLinkClass =
  'text-sm text-primary visited:text-primary hover:text-primary-hover hover:underline';

